module.exports = __webpack_public_path__ + "static/media/amr.5536c813.jpg";